import { render, staticRenderFns } from "./KanbanGroupOperationsCandidates.vue?vue&type=template&id=bcb5ab52&scoped=true&"
import script from "./KanbanGroupOperationsCandidates.vue?vue&type=script&lang=js&"
export * from "./KanbanGroupOperationsCandidates.vue?vue&type=script&lang=js&"
import style0 from "./KanbanGroupOperationsCandidates.vue?vue&type=style&index=0&id=bcb5ab52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb5ab52",
  null
  
)

/* custom blocks */
import block0 from "./KanbanGroupOperationsCandidates.vue?vue&type=custom&index=0&blockType=i18n&locale=ru&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./KanbanGroupOperationsCandidates.vue?vue&type=custom&index=1&blockType=i18n&locale=en&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
